import React, { createContext, useContext, useEffect, useState } from "react";
import { setAccessToken } from "@/api/client";
import { useMe } from "@/api/auth";
import type { User } from "@/api/types";

interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

const AuthContext = createContext<AuthContextType>({
  user: null,
  isAuthenticated: false,
  isLoading: true,
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false);
  const { data: user, isLoading, isError } = useMe();

  useEffect(() => {
    const refresh = localStorage.getItem("refresh_token");
    if (!refresh) {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    if (!isLoading) {
      setReady(true);
    }
  }, [isLoading]);

  const isAuthenticated = !!user && !isError;

  if (!ready && isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent" />
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user: user ?? null, isAuthenticated, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
